import { CalendarGranularity } from '../types';

const GRANULARITY_OPTIONS: readonly Readonly<{
    value: CalendarGranularity;
    label: string;
}>[] = [
    { value: CalendarGranularity.Month, label: 'Mois' },
    { value: CalendarGranularity.Week, label: 'Semaine' },
    { value: CalendarGranularity.Day, label: 'Jour' },
];

const CONTAINER_CLASS = 'flex rounded-full border border-light-gray bg-primary-light p-1';
const ITEM_BASE_CLASS = 'rounded-full px-3 py-1.5 text-small font-medium';
const ITEM_ACTIVE_CLASS = 'bg-white text-dark-gray';
const ITEM_INACTIVE_CLASS = 'text-gray';

type GranularitySwitcherProps = Readonly<{
    granularity: CalendarGranularity;
    onGranularityChange: (next: CalendarGranularity) => void;
}>;

export function GranularitySwitcher({
    granularity,
    onGranularityChange,
}: GranularitySwitcherProps) {
    return (
        <div className={CONTAINER_CLASS} role="tablist" aria-label="Granularité du calendrier">
            {GRANULARITY_OPTIONS.map(option => {
                const isActive = option.value === granularity;
                return (
                    <button
                        key={option.value}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        onClick={() => onGranularityChange(option.value)}
                        className={`${ITEM_BASE_CLASS} ${isActive ? ITEM_ACTIVE_CLASS : ITEM_INACTIVE_CLASS}`}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
